import { render, staticRenderFns } from "./CalendarEventPopoverReminders.vue?vue&type=template&id=10d45573"
import script from "./CalendarEventPopoverReminders.vue?vue&type=script&lang=js"
export * from "./CalendarEventPopoverReminders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports